module.exports = __webpack_public_path__ + "static/img/index_statistics_bg.e66bf154.png";